import "@/js/i18next.min.js";
import en from "@/locales/en.json";
import zhCN from "@/locales/zh-CN.json";
import zh from "@/locales/zh.json";

/**
 *
 * 优先级：浏览器语言 > IP地区 > 兜底zh-CN
 */
async function getDefaultLangByIP() {
  const browserLang = navigator.language || navigator.userLanguage;
  const langMap = {
    "zh-CN": "zh-CN", // 简体中文
    "zh-TW": "zh", // 繁体中文（台湾）
    "zh-HK": "zh", // 繁体中文（香港）
    en: "en", // 英文
    "en-US": "en", // 美式英文
    "en-GB": "en", // 英式英文
  };
  if (browserLang in langMap) {
    return langMap[browserLang];
  }
}

// 等待DOM加载完成后执行
document.addEventListener("DOMContentLoaded", async function () {
  let preferredLng = localStorage.getItem("preferred-language");

  if (!preferredLng || preferredLng === "null") {
    preferredLng = await getDefaultLangByIP();
    localStorage.setItem("preferred-language", preferredLng);
  }

  i18next
    .init({
      lng: preferredLng,
      fallbackLng: "zh-CN",
      debug: process.env.NODE_ENV === "development" ? true : false,
      resources: {
        en: { translation: en },
        "zh-CN": { translation: zhCN },
        zh: { translation: zh },
      },
      interpolation: {
        escapeValue: false,
      },
    })
    .then(function (t) {
      updateContent();
    });
});

function updateContent() {
  console.log("update---");
  // 1. 更新所有带有 data-i18n 属性的元素的文本内容
  document.querySelectorAll("[data-i18n]").forEach((el) => {
    const key = el.getAttribute("data-i18n");
    const options = getOptions(el);
    if (key) {
      el.textContent = i18next.t(key, options);
    }
  });

  // 2. 更新所有带有 data-i18n-attr 属性的元素的HTML属性（如 placeholder、img title 等）
  document.querySelectorAll("[data-i18n-attr]").forEach((el) => {
    const attrConfig = el.getAttribute("data-i18n-attr");
    const [attrName, key] = attrConfig.split(":");
    if (attrName && key) {
      el.setAttribute(attrName, i18next.t(key));
    }
  });

  // 3. （可选）专门更新 img 标签的 title 属性（使用 data-i18n-title）
  document.querySelectorAll("img[data-i18n-title]").forEach((imgEl) => {
    const key = imgEl.getAttribute("data-i18n-title");
    const options = getOptions(imgEl);
    if (key) {
      imgEl.setAttribute("title", i18next.t(key, options));
    }
  });

  // 4. 更新页面标题
  const titleEl = document.querySelector("title[data-i18n]");
  if (titleEl) {
    const key = titleEl.getAttribute("data-i18n");
    const options = getOptions(titleEl);
    document.title = i18next.t(key, options);
  }

  // 5. 更新 Meta 描述（修复选择器与属性不匹配问题）
  document
    .querySelectorAll('meta[name="keywords"][data-i18n]')
    .forEach((meta) => {
      const key = meta.getAttribute("data-i18n");
      const options = getOptions(meta);
      meta.setAttribute("content", i18next.t(key, options));
    });
  document
    .querySelectorAll('meta[name="description"][data-i18n]')
    .forEach((meta) => {
      const key = meta.getAttribute("data-i18n");
      const options = getOptions(meta);
      meta.setAttribute("content", i18next.t(key, options));
    });

  document.querySelectorAll("[data-i18n-html]").forEach((el) => {
    const key = el.getAttribute("data-i18n-html");
    const options = getOptions(el);
    if (key) {
      const htmlContent = i18next.t(key, options);
      el.innerHTML = htmlContent; // 自动赋值 innerHTML
    }
  });

  //7. 自动更新HTML文档的语言属性，有助于SEO和无障碍访问
  document.documentElement.lang = i18next.language;
}

function changeLanguage(lng) {
  i18next.changeLanguage(lng).then(() => {
    updateContent();
    localStorage.setItem("preferred-language", lng);
  });
}

function getOptions(element) {
  const optionsAttr = element.getAttribute("data-i18n-options");
  if (optionsAttr) {
    try {
      return JSON.parse(optionsAttr);
    } catch (e) {
      console.warn(`Invalid JSON in data-i18n-options: ${optionsAttr}`, e);
      return {};
    }
  }
  return {};
}

// 暴露必要的方法到全局作用域
window.i18n = {
  changeLanguage: changeLanguage,
  t: i18next.t,
};
